import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./NewsPage.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

const NewsPage = () => {
  const navigate = useNavigate();

  const [newsList, setNewsList] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [error, setError] = useState(null);

  // ==============================
  // FETCH NEWS
  // ==============================
  const fetchNews = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`${API_BASE_URL}/news`);
      setNewsList(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error("Error fetching news:", err);
      setError("Failed to fetch news. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
  }, []);

  // ==============================
  // SEARCH FILTER
  // ==============================
  const filteredNews = newsList.filter((news) =>
    news?.title?.toLowerCase().includes(search.toLowerCase())
  );

  // ==============================
  // NAVIGATION HANDLERS
  // ==============================
  const handleAddNews = () => navigate("/admin-panel/news/add");
  const handleView = (id) => navigate(`/news/view/${id}`);
  const handleEdit = (id) => navigate(`/news/edit/${id}`);

  // ==============================
  // DELETE NEWS (BACKEND CONNECTED)
  // ==============================
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this news item?"
    );

    if (!confirmDelete) return;

    try {
      setDeletingId(id);

      await axios.delete(`${API_BASE_URL}/news/${id}`);

      // Remove deleted item from UI
      setNewsList((prev) => prev.filter((news) => news._id !== id));

      alert("News item deleted successfully!");
    } catch (err) {
      console.error("Delete Error:", err);
      alert(
        err.response?.data?.message ||
          "Failed to delete news. Please try again."
      );
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <div className="news-container">
      <h1 className="news-title">NEWS PAGE</h1>

      <div className="news-controls">
        <button className="news-btn news-btn-primary" onClick={handleAddNews}>
          + Add News
        </button>

        <button
          className="news-btn news-btn-gold"
          onClick={() => window.print()}
        >
          Print
        </button>
      </div>

      <div className="news-search-container">
        <input
          type="text"
          placeholder="Search news by title..."
          className="news-search-input"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {loading && <p>Loading news...</p>}
      {error && <p className="news-error">{error}</p>}

      {!loading && !error && (
        <table className="news-table">
          <thead>
            <tr>
              <th>SN</th>
              <th>Title</th>
              <th>Description</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredNews.length > 0 ? (
              filteredNews.map((news, index) => (
                <tr key={news._id}>
                  <td>{index + 1}</td>
                  <td>{news?.title}</td>
                  <td>{news?.description}</td>
                  <td>
                    <button
                      className="news-action view"
                      onClick={() => handleView(news._id)}
                    >
                      View
                    </button>

                    <button
                      className="news-action edit"
                      onClick={() => handleEdit(news._id)}
                    >
                      Edit
                    </button>

                    <button
                      className="news-action delete"
                      disabled={deletingId === news._id}
                      onClick={() => handleDelete(news._id)}
                    >
                      {deletingId === news._id
                        ? "Deleting..."
                        : "Delete"}
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="news-no-data">
                  No news found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default NewsPage;